import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditFilled,
} from '@ant-design/icons';
import { Card, Col, Row, Table, Input, Button } from 'antd';
import { customerApiEndpoints } from '@/api/endpoints';
import { handlePatchUpdate, handleDeleteApi } from '@/api/crud';
import { useFetch } from '@/hooks';
import { globalSearch } from '@/utils/search/Search';
import { enablePaginationOrNot } from '@/utils/common';
import ConfirmModal from '@/components/reusable/modal/confirmModal';
import { BsLockFill } from 'react-icons/bs';
import ChangePasswordModal from '@/pages/changePassword/ChangePasswordModal';

const baseColumns = [
  {
    title: 'S.N.',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
  },
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
    align: 'center'
  },
  {
    title: 'Full Name',
    dataIndex: 'name',
    key: 'name',
    align: 'left',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    align: 'left',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile',
    key: 'mobile',
    align: 'left',
  },
  // {
  //   title: 'Company',
  //   dataIndex: 'companies',
  //   key: 'companies',
  //   align: 'center',
  // },
  // {
  //   title: 'Role',
  //   dataIndex: 'role',
  //   key: 'role',
  //   align: 'center',
  // },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    width: 100,
  },
];

const SuperAdminUserList = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openUserActivateModal, setOpenUserActivateModal] = useState(false);
  const [openUserDeactivateModal, setOpenUserDeactivateModal] = useState(false);
  const [openIsAdminModal, setOpenIsAdminModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isShow, setIsShow] = useState();
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUsername, setSelectedUsername] = useState(null);

  const { data, isLoading, refresh } = useFetch(
    customerApiEndpoints.superAdminRetrieveList,
  );

  const [id, setId] = useState(null);

  const handleCancel = () => {
    setOpen(false);
    setOpenUserActivateModal(false);
    setOpenUserDeactivateModal(false);
    setOpenIsAdminModal(false);
    setId(null);
  };

  const handleUserActivate = () => {
    handlePatchUpdate(
      customerApiEndpoints.active,
      { userId: id },
      setLoading,
      refresh,
    );
    setOpenUserActivateModal(false);
  };

  const handleDeactivateUserModal = () => {
    handleDeleteApi(id, customerApiEndpoints.delete, setLoading, refresh);
    setOpenUserDeactivateModal(false);
  };
  useEffect(() => {
    const userIsShow = sessionStorage.getItem('isShow');

    setIsShow(userIsShow);
  }, []);

  // Determine columns dynamically based on `isShow` value
  // const getColumns = () => {
  //   let columns = [...baseColumns]; // Start with the base columns

  //   if (!isShow) {
  //     columns.push(
  //       {
  //         title: 'Company',
  //         dataIndex: 'companies',
  //         key: 'companies',
  //         align: 'center',
  //       },
  //       {
  //         title: 'Role',
  //         dataIndex: 'role',
  //         key: 'role',
  //         align: 'center',
  //       },
  //     );
  //   }

  //   return columns;
  // };
  const handlePasswordChange = () => {
    setOpenPasswordModal(false);
  };
  return (
    <>
      <ConfirmModal
        open={open}
        handleOk={() => setOpen(false)}
        handleCancel={handleCancel}
      />
      <ConfirmModal
        defaultType="primary"
        OkBgColor="green"
        open={openUserActivateModal}
        handleOk={handleUserActivate}
        handleCancel={handleCancel}
      />
      <ConfirmModal
        open={openUserDeactivateModal}
        handleOk={handleDeactivateUserModal}
        handleCancel={handleCancel}
      />
      <ConfirmModal
        open={openIsAdminModal}
        handleOk={() =>
          handlePatchUpdate(
            customerApiEndpoints.isAdmin,
            { userId: id },
            setLoading,
            refresh,
          )
        }
        handleCancel={handleCancel}
      />
      <ChangePasswordModal
        open={openPasswordModal}
        loading={loading}
        onCancel={() => setOpenPasswordModal(false)}
        onFinish={handlePasswordChange}
        selectedUserId={selectedUserId}
        username={selectedUsername}
        resetApi={customerApiEndpoints.resetAdminPassword}
      />
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="outlined"
              title={
                <Link to="/admin/user/create/">
                  <Button className="centered" size="medium" type="primary">
                    <PlusCircleOutlined />
                    Create
                  </Button>
                </Link>
              }
              extra={
                <div className="flex flex-col items-center justify-center">
                  <Input
                    className="header-search"
                    name="query"
                    value={searchQuery}
                    placeholder="Search customer..."
                    prefix={<SearchOutlined />}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  scroll={{ x: true }}
                  size="small"
                  bordered
                  loading={isLoading || loading}
                  // columns={getColumns(data)}
                  columns={baseColumns?.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: {
                        padding: '6px 10px',
                      },
                    }),
                  }))}
                  expandable={true}
                  className="ant-border-space"
                  pagination={!isLoading ? enablePaginationOrNot(data) : false}
                  dataSource={
                    !isLoading
                      ? globalSearch(data, searchQuery)?.map((user, index) => ({
                          key: user.referenceId,
                          index: index + 1,
                          username: user.username,
                          name: `${user.firstName} ${user.lastName}`,
                          email: user.email,
                          mobile: user.mobileNumber,
                          subscription: user.subscription,
                          remainingDays: user.remainingDays,
                          // ...(isShow === false && {
                          companies: user.companies?.join(','),
                          role: user.role || '-',
                          // }),
                          action: (
                            <div className="ant-action flex justify-center gap-1">
                              <div className="ant-button-delete">
                                <Link
                                  size="medium"
                                  to={`/admin/user/${user.referenceId}/edit/`}
                                >
                                  <EditFilled />
                                </Link>{' '}
                              </div>
                              <div className="ant-button-delete">
                                <Link
                                  onClick={() => {
                                    setSelectedUserId(user.referenceId);
                                    setSelectedUsername(user.username);
                                    setOpenPasswordModal(true);
                                  }}
                                  style={{ color: 'red' }}
                                  size="medium"
                                >
                                  <BsLockFill />
                                </Link>{' '}
                              </div>
                            </div>
                          ),
                        }))
                      : []
                  }
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SuperAdminUserList;
